import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { reducer as notifications } from "react-notification-system-redux";

import AppInfoReducer from "./AppInfoReducer";
import ThemeReducer from "./ThemeReducer";
import WebsocketReducer from "./WebsocketReducer";
import NotifierReducer from "./NotifierReducer";
import UiReducer from "./UiReducer";
import UserReducer from "./UserReducer";
import ConfigReducer from "./ConfigReducer";
import EmployeeReducer from "./EmployeeReducer";
import TimeReducer from "./TimeReducer";
import KeyboardReducer from "./KeyboardReducer";
import userSettingsReducer from "./UserSettingsReducer";
import codePerTagsReducer from "./CodePerTagsReducer";
import personnelTagsReducer from "./PersonnelTagsReducer";
import createGenericReducer from "./GenericReducer";
import personnelEmergencyContactReducer from "./PersonnelEmergencyContactReducer";
import personnelPhotosReducer from "./PersonnelPhotosReducer";
import applicantsReducer from "./ApplicantsReducer";
import trainingCourseReducer from "./TrainingCourseReducer";
import trainingParticipantReducer from "./TrainingParticipantReducer";
import trainingCertificationReducer from "./TrainingCertificationReducer";
import trainingCostReducer from "./TrainingCostReducer";
import perNotesReducer from "./PerNotesReducer";
import personnelAssignmentHistoryReducer from "./PersonnelAssignmentHistoryReducer";
import ptsAgencyReducer from "./PtsAgencyReducer";
import PersonDialogReducer from "./PersonDialogReducer";
import DictionaryReducer from "./DictionaryReducer";
import DialogsReducer from "./DialogsReducer";
import PermissionsReducer from "./PermissionsReducer";
import DataUpdateReducer from "./DataUpdateReducer";
import perFilterReducer from "./PerFilterReducer";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    theme: ThemeReducer,
    websocket: WebsocketReducer,
    notifier: NotifierReducer,
    notifications: notifications,
    ui: UiReducer,
    user: UserReducer,
    config: ConfigReducer,
    appInfo: AppInfoReducer,
    employees: EmployeeReducer,
    time: TimeReducer,
    keyboard: KeyboardReducer,
    userSettings: userSettingsReducer,
    tags: codePerTagsReducer,
    personnelTags: personnelTagsReducer,
    personnelEmergencyContacts: personnelEmergencyContactReducer,
    personnelAssignmentHistory: personnelAssignmentHistoryReducer,
    personnelPhotos: personnelPhotosReducer,
    applicants: applicantsReducer,
    trainingCourses: trainingCourseReducer,
    trainingParticipants: trainingParticipantReducer,
    trainingCertifications: trainingCertificationReducer,
    trainingCosts: trainingCostReducer,
    notes: perNotesReducer,
    ptsAgencies: ptsAgencyReducer,
    personDialog: PersonDialogReducer,
    dictionary: DictionaryReducer,
    dialogs: DialogsReducer,
    permissions: PermissionsReducer,
    dataUpdate: DataUpdateReducer,
    filters: perFilterReducer,
    educationCodes: createGenericReducer(
      "code-per-education",
      "Education Codes"
    ),
    departmentCodes: createGenericReducer(
      "code-per-department",
      "Department Codes"
    ),
    rankCodes: createGenericReducer("code-per-rank", "Rank Codes"),
    relationshipsCodes: createGenericReducer(
      "code-per-relationships",
      "Relationships Codes"
    ),
    sectionCodes: createGenericReducer("code-per-section", "Section Codes"),
    titlePositionCodes: createGenericReducer(
      "code-per-title-position",
      "Title/Position Codes"
    ),
    applicantStatusCodes: createGenericReducer(
      "code-per-applicant-status",
      "Applicant Status Codes"
    ),
    applicantTestResultCodes: createGenericReducer(
      "code-per-applicant-test-result",
      "Applicant Test Result Codes"
    ),
    employmentStatusCodes: createGenericReducer(
      "code-per-employment-status",
      "Employment Status Codes"
    ),
    trainingCostCodes: createGenericReducer(
      "code-per-training-cost",
      "Training Cost Codes"
    ),
  });

export default createRootReducer;
